import React, { useState, useEffect } from "react"
import { Redirect, useHistory } from 'react-router-dom'
import { useQuery } from '../utils/tools'
import { CircularProgress, Alert } from '@mui/material'
// import CircularProgress from '@mui/material/CircularProgress';
// import { useGeneral } from './general'  
import styles from './Login.module.scss'
import useUser from '../hooks/useUser'
import axios from "axios"


export default function AutoLogin() {

    // const query = useQuery()
    const history = useHistory();
    const [statusCode, setStatusCode] = useState(false)
    const [Message, setMessage] = useState()
    // const [email, setEmail] = useState(query.get('email'))
    // const [password, setPassword] = useState(query.get('password'))
    const { logout, login, isLoggedIn } = useUser()
    
    useEffect(() => {
        const performAutoLogin = async () => {
          if (isLoggedIn) {
            await logout();
          }

          await axios({
                      method: 'get',
                      url:'/api/users/QuantLabTokenLogin',
                    })
                    .then(res => 
                        {
                            if (res.status === 200) {
                                login(res.data)
                                localStorage.setItem('FE_USER_DATA',JSON.stringify(res?.data))
                                // axios.defaults.headers.common['Authorization'] = `Bearer ${res?.data?.token}`  
                                setStatusCode(false)
                            } else {
                                setStatusCode(res.status)
                                setMessage("Somthing went wrong! Please check the Email and Password!")
                            }
                    }).catch(e => {
                        setStatusCode(e)
                })
    
          // Redirect to a specific route or dashboard after login
          history.push("/dashboard");
        };
    
        performAutoLogin();
        return () => {}
      }, []);
    

    return (
        
        <>
        <div style={{justifyContent:"center",display:'flex',alignItems:"center", height:"80Vh"}}>
            {statusCode?<Alert style={{width:"500px"}} severity="error" classes={{root: styles['error']}}>{Message}</Alert>:<CircularProgress size={200}/>}
            <br/>
        </div>
        </>
    )
}